import 'rc-slider/assets/index.css'
import 'rc-tooltip/assets/bootstrap.css'
import './styles.scss'
import React from 'react'
// import Tooltip from 'rc-tooltip';
import Slider, { Range } from 'rc-slider'

const createSliderWithTooltip = Slider.createSliderWithTooltip
const RangeWithTooltip = createSliderWithTooltip(Slider.Range)
// const Handle = Slider.Handle;

const handleStyle = {
  border: '2px solid #dd601d',
  width: 25,
  height: 25,
  backgroundColor: '#fff',
  outline: 'none',
}

const tooltipStyle = {}
const rangeStyle = {
  railStyle: {
    height: 6,
    marginTop: 5,
  },
  trackStyle: [
    {
      backgroundColor: '#dd601d',
      height: 6,
      marginTop: 5,
    },
  ],
  handleStyle: [handleStyle, handleStyle],
}

export default class Index extends React.Component {
  render() {
    let range = <Range {...this.props} {...rangeStyle} />

    if (this.props.tooltip) range = <RangeWithTooltip {...this.props} {...rangeStyle} {...tooltipStyle} />

    return <div className='nx-range'>{range}</div>
  }
}
